export default __webpack_public_path__ + "static/media/desktop.dde8e5b2.png";